import React, { useState, useRef, useEffect } from 'react';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';

interface LineActionsProps {
  lineId: string;
  isMerged?: boolean;
  onDelete: (id: string) => void;
  onMerge: (id: string) => void;
  onSplit: (id: string) => void;
  isLast: boolean;
}

const LineActions: React.FC<LineActionsProps> = ({
  lineId,
  isMerged,
  onDelete,
  onMerge,
  onSplit,
  isLast,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="p-1 rounded hover:bg-gray-100"
      >
        <EllipsisVerticalIcon className="w-4 h-4 text-gray-400" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 z-50 bg-white border border-gray-200 rounded-lg shadow-lg py-1 w-40">
          <button
            onClick={() => { onDelete(lineId); setOpen(false); }}
            className="w-full text-left px-3 py-1.5 text-sm text-red-600 hover:bg-red-50"
          >
            Supprimer
          </button>
          {!isLast && (
            <button
              onClick={() => { onMerge(lineId); setOpen(false); }}
              className="w-full text-left px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
            >
              Fusionner avec suivante
            </button>
          )}
          {isMerged && (
            <button
              onClick={() => { onSplit(lineId); setOpen(false); }}
              className="w-full text-left px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
            >
              Scinder
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default LineActions;
